const defaultState = {
  lang: 'th',
  mode: 'light'
};

export default defaultState;